import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import {
  // ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from 'recharts'

const ProjectsChartWidget = ({ data, nameKey="name", dataKey="value", headerTotalCount, selectedRegionValue, selectedDivisionValue} :any) => {
  data = data || [
    { "name": "-", "value": "-"},
    { "name": "-", "value": "-"},
    { "name": "-", "value": "-"},
    { "name": "-", "value": "-"},
    { "name": "-", "value": "-"},
  ]

  let chartData = data;
  let currentNameKey = nameKey;
  let currentDataKey = dataKey;

  if(!!selectedRegionValue && selectedRegionValue !== "All Regions") {
    const filteredData = data.filter((ele:any) => ele.regionId === parseInt(selectedRegionValue))
    
    if(filteredData.length > 0 && filteredData[0].countsPerProjectType) {
      chartData = Object.entries(filteredData[0].countsPerProjectType).map(([name, value]) => ({
        name,
        value
      }));

      currentNameKey = "name";
      currentDataKey = "value";
    }
  }
  else if(!!selectedDivisionValue && selectedDivisionValue !== "All Divisions") {
    const filteredData = data.filter((ele:any) => ele.divisionId === parseInt(selectedDivisionValue))
    
    if(filteredData.length > 0 && filteredData[0].countsPerProjectType) {
      chartData = Object.entries(filteredData[0].countsPerProjectType).map(([name, value]) => ({
        name,
        value
      }));

      currentNameKey = "name";
      currentDataKey = "value";
    }
  }

  const pieChartDisplayFunc = () => {
    return (
      <PieChart width={400} height={250}>
        <Pie data={chartData} nameKey={currentNameKey} dataKey={currentDataKey} cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label>
        {Array.isArray(chartData) && chartData.map((_ele:any, index:any) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
        </Pie>
      </PieChart>
    )
  }

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
  
  return (
    <>
      <div className="projects-chart-widget">
        <header className="projects-chart-widget__header">
          <h2 className="projects-chart-widget__title">Projects</h2>
          <h2 className="overdue-findings-chart-widget__totalCount">{headerTotalCount}</h2>
        </header>

        <div>
          <div className="projects-chart-widget__body">
            <div className="projects-chart-widget__content">
              {pieChartDisplayFunc()}

              <section className="projects-chart-widget__content-right">
                <ul>
                  {
                    Array.isArray(chartData) && chartData.map((ele:any, index:any) => {
                      return (
                        <>
                          <div>
                            <span>
                              <FontAwesomeIcon icon={faCircle} color={COLORS[index % COLORS.length]}/>
                              <li>{ele[currentNameKey]}</li>
                            </span>
                            <span>
                              {isNaN(Number(ele[currentDataKey])) ? 0 : (ele[currentDataKey] || 0)}
                            </span>
                          </div>
                          <hr/>
                        </>
                      )
                    })
                  }
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProjectsChartWidget